import {
  POST_ORG_USER,
  POST_ORG_USER_SUCCESSFUL,
  POST_ORG_USER_FAILED,
  PUT_ORG_USER,
  PUT_ORG_USER_SUCCESSFUL,
  PUT_ORG_USER_FAILED,
  DELETE_ORGANIZATION_USER,
  DELETE_ORGANIZATION_USER_SUCCESSFUL,
  DELETE_ORGANIZATION_USER_FAILED,
  CLEAR_ALL_ORG_USER_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  createOrgUserMessage: null,
  createOrgUserError: null,
  orgUserCreating: false,
  editOrgUserMessage: null,
  editOrgUserError: null,
  orgUserEditing: false,
  deleteOrgUserMessage: null,
  deleteOrgUserError: null,
  orgUserDeleting: false,
};

const orgUsers = (state = initialState, action) => {
  switch (action.type) {
    case POST_ORG_USER: 
      state = { 
        ...state,
        orgUserCreating: true,
        createOrgUserMessage: null,
        createOrgUserError: null,
      }
      break;
    case POST_ORG_USER_SUCCESSFUL: 
      state = { 
        ...state,
        orgUserCreating: false,
        createOrgUserMessage: action.payload.postOrgUserSuccessfulMessage
      }
      break;
    case POST_ORG_USER_FAILED: 
      state = { 
        ...state,
        orgUserCreating: false,
        createOrgUserError: action.payload.postOrgUserError
      }
      break;
    case PUT_ORG_USER: 
      state = { 
        ...state,
        orgUserEditing: true,
        editOrgUserMessage: null,
        editOrgUserError: null,
      }
      break;
    case PUT_ORG_USER_SUCCESSFUL: 
      state = { 
        ...state,
        orgUserEditing: false,
        editOrgUserMessage: action.payload.putOrgUserSuccessfulMessage
      }
      break;
    case PUT_ORG_USER_FAILED: 
      state = { 
        ...state,
        orgUserEditing: false, 
        editOrgUserError: action.payload.putOrgUserError
      }
      break;
    case DELETE_ORGANIZATION_USER: 
      state = { 
        ...state,
        orgUserDeleting: true, 
        deleteOrgUserMessage: null,
        deleteOrgUserError: null,
      }
      break;
    case DELETE_ORGANIZATION_USER_SUCCESSFUL: 
      state = { 
        ...state,
        orgUserDeleting: false, 
        deleteOrgUserMessage: action.payload.deleteOrgUserSuccessfulMessage
      }
      break;
    case DELETE_ORGANIZATION_USER_FAILED: 
      state = { 
        ...state,
        orgUserDeleting: false, 
        deleteOrgUserError: action.payload.deleteOrgUserError
      }
      break;            
    case CLEAR_ALL_ORG_USER_MESSAGES_SUCCESSFUL: 
      state = { 
        ...state,     
        createOrgUserMessage: null,
        createOrgUserError: null,
        orgUserCreating: false,
        editOrgUserMessage: null,
        editOrgUserError: null,
        orgUserEditing: false,
        deleteOrgUserMessage: null,
        deleteOrgUserError: null,
        orgUserDeleting: false,   
      }
      break;                  
    default:
      return state;
  }

  return state;
}

export default orgUsers;